<template>
  <header class="header" :class="{ 
    'header--modalOpen': isMenuOpen, 
    'header--content-centered': isCentered 
  }" id="header">
    <h2 class="header__logo" v-if="!isMenuOpen && !hasSectionTitle" :class="{ 'header__logo--white': isLogoWhite}">
      Annamor <br />
      Studio.
    </h2>
    <h1 class="header__page-title" v-if="hasSectionTitle">{{ title }}</h1>
  </header>
</template>

<script>
export default {
  props: {
    isMenuOpen: {
      type: Boolean
    },
    hasSectionTitle: {
      type: Boolean,
      default: false
    },
    isLogoWhite: {
      type: Boolean,
      default: false,
    },
    isCentered: {
      type: Boolean,
      default: false,
    },  
    title: {
      type: String,
      default: ""
    }
  }
};
</script>
